import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import PropTypes from "prop-types";
import Input from "semantic-ui-react/dist/commonjs/elements/Input";
import Accordion from "semantic-ui-react/dist/commonjs/modules/Accordion";

import Tab from "semantic-ui-react/dist/commonjs/modules/Tab";
import { getFaqs, categories } from "../../lib/faqData";
import scrollToElement from 'scroll-to-element';

function toAccrodionItem(item) {
  return {
    key: item.key,
    title: item.title,
    content: {
      key: item.key,
      content: <div dangerouslySetInnerHTML={{ __html: item.content }}></div>,
    },
  };
}

function debug(value) {
//  console.log(value);
  return value;
}

class Faq extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  state = {};
  render() {
    document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜よくあるご質問';
    const { type } = this.props;
    const items = getFaqs();
//    console.log(items);

    const history = this.context.router.history;

    window.toInner = function(event, elem){
      event.preventDefault();
      const href = elem.attributes.href.value;
      history.push(href);
      const match = href.match(/\#(.*)$/);
      const hash = match && match[1];
      setTimeout(() => {
        const targetElement =
          (hash && document.getElementById(hash)) || document.body;
          scrollToElement(targetElement, {
            offset: window.innerWidth >= 1024 ? -120 : -60
          })
      }, 100);
      return false;
    }

    let panes = null;
    if (this.state.searchText) {
      panes = [
        {
          menuItem: "検索結果",
          render: () => (
            <Tab.Pane>
              <div className="tab_panel">
                <Accordion
                  panels={items
                    .filter(
                      item =>
                        item.title.includes(this.state.searchText) ||
                        item.content.includes(this.state.searchText)
                    )
                    .map(toAccrodionItem)}
                  styled
                />
              </div>
            </Tab.Pane>
          ),
        },
      ];
    } else {
      panes = categories.map((category, index) => ({
        menuItem: category.name,
        render: () => (
          <Tab.Pane>
            <div className="tab_panel">
              <Accordion
                panels={items
                  .filter(item => item.category === category.slug)
                  .map(toAccrodionItem)}
                styled
              />
            </div>
          </Tab.Pane>
        ),
      }));
    }

    return (
      <div className="container">
        {breadcrumbs(type, [{ text: "よくある質問" }])}
        
        <div className="faq">
          <div className="toppanel">
            <div>
              <div className="title">よくある質問</div>
              <div className="text">
                <span>お客様からいただいたよくある質問にお答え</span>
                <span>しています。まずは参考にしてください。</span>
                <span>他のご質問や解決しない場合は、</span>
                <span>お問合せください。</span>
              </div>
            </div>
          </div>
          <div className="content">
            <div className="searach_keyword">
              <span>フリーワード検索</span>
              <Input
                focus
                action={{ icon: "search" }}
                placeholder="Search..."
                onChange={(event, element) => {
                  this.setState({ searchText: element.value });
                }}
              />
            </div>
            <Tab panes={panes} renderActiveOnly={true} />
          </div>
        </div>
      </div>
    );
  }
}

export const faq = type => {
  return <Faq {...{ type }} />;
};



// WEBPACK FOOTER //
// ./pages/new/faq.jsx